import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useState } from "react";

const ReactQueryProvider = ({ children }) => {
  const [client] = useState(
  () =>
    new QueryClient({
      defaultOptions: {
        queries: {
          retry: (failureCount, error) => {
            // Retry network errors up to 3 times
            if (error?.code === 'NETWORK_ERROR' || error?.message?.includes('Network Error')) {
              return failureCount < 3;
            }
            // Don't retry 4xx errors (client errors)
            if (error?.response?.status >= 400 && error?.response?.status < 500) {
              return false;
            }
            // Retry 5xx errors up to 2 times
            if (error?.response?.status >= 500) {
              return failureCount < 2;
            }
            return false;
          },
          retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
          staleTime: 5 * 60 * 1000, // 5 minutes
          gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
          refetchOnWindowFocus: false, // Prevent refetch on window focus
          refetchOnReconnect: true, // Refetch when reconnecting
        },
        mutations: {
          retry: false, // Don't retry mutations
        },
      },
    })
);

  return (
    <QueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
